import { h, Component } from 'preact';
import { withTranslation } from 'react-i18next';
import { AppConstant } from '../../constant/AppConstant';

// Bootstrap's reboot hard-sets `pre { color: #212529 }`, which on the dark
// theme's --kt-surface2 panel (#2c2c2e) is very nearly invisible — the error
// detail was unreadable exactly when someone needed to read it. These blocks
// paint their own foreground/background from the brand tokens instead of
// inheriting either Bootstrap's near-black or the heading's orange.
export const PRE_STYLE = [
  'margin: 4px 0 12px',
  'padding: 8px',
  'background: var(--kt-bg)',
  'border: 1px solid var(--kt-border)',
  'border-radius: 3px',
  'color: var(--kt-text)',
  'font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  'font-size: 12px',
  'line-height: 1.45',
  'white-space: pre-wrap',
  'overflow-wrap: anywhere',
  'overflow-x: auto',
  'max-height: 40vh',
].join('; ');

const LABEL_STYLE = 'display: block; color: var(--kt-muted); font-size: 11px; letter-spacing: 0.03em; text-transform: uppercase;';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Log to a remote service if available
    if (window.logErrorToService) {
      window.logErrorToService({
        error: error.toString(),
        stack: error.stack,
        componentStack: errorInfo.componentStack,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      });
    }

    this.setState({
      hasError: true,
      error,
      errorInfo
    });
  }

  render(props, state) {
    const { t } = this.props;

    if (state.hasError) {
      // Show error UI
      return (
        <div style="padding: 20px; background: rgba(255,159,10,0.15); border: 1px solid var(--kt-orange); border-radius: 5px; margin: 20px;">
          <h3 style="color: var(--kt-orange); margin-top: 0;">
            <i class="fa fa-exclamation-triangle" /> {t(AppConstant.ERROR_SOMETHING_WENT_WRONG)}
          </h3>
          <details style="font-size: 12px; color: var(--kt-text);">
            <summary style="cursor: pointer; margin-bottom: 10px; color: var(--kt-orange);">
              {t(AppConstant.ERROR_SEE_DETAILS)}
            </summary>
            <div style="background: var(--kt-surface2); padding: 10px; border-radius: 3px; margin-top: 10px; color: var(--kt-text);">
              <strong style={LABEL_STYLE}>{t(AppConstant.ERROR_LABEL)}</strong>
              <pre style={PRE_STYLE}>{state.error && state.error.toString()}</pre>

              <strong style={LABEL_STYLE}>{t(AppConstant.ERROR_STACK_LABEL)}</strong>
              <pre style={PRE_STYLE}>{state.error && state.error.stack}</pre>

              <strong style={LABEL_STYLE}>{t(AppConstant.ERROR_COMPONENT_STACK_LABEL)}</strong>
              <pre style={PRE_STYLE}>{state.errorInfo && state.errorInfo.componentStack}</pre>
            </div>
          </details>
          <button
            class="btn btn-primary mt-3"
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              window.location.reload();
            }}
          >
            <i class="fa fa-refresh" /> {t(AppConstant.ERROR_RELOAD_PAGE)}
          </button>
        </div>
      );
    }

    return props.children;
  }
}

export default withTranslation()(ErrorBoundary);
